module.exports = __webpack_public_path__ + "img/l.a5581a7f.jpg";